<template>
<v-card hover>
	<v-chip class='caption ma-1' label outlined>
		<v-icon left>mdi-star-circle</v-icon>
		{{ item.title }}
	</v-chip>
	</v-card>
</template>

<script>
export default {
	props: {
		item: Object
	}
}
</script>